"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignEnvironmentMapForThreeJsData = exports.assignEnvironmentMapForThreeJsDataObject = void 0;
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const gl_matrix_1 = require("gl-matrix");
const THREE = __importStar(require("three"));
const ThreejsData_1 = require("../../types/ThreejsData");
const assignEnvironmentMapForThreeJsDataObject = (data, environmentMap, environmentMapType, environmentMapIntensity, environmentMapRotation) => {
    const rotationMatrix = new THREE.Matrix4()
        .fromArray(gl_matrix_1.mat4.fromQuat(gl_matrix_1.mat4.create(), gl_matrix_1.quat.fromValues(environmentMapRotation[0], environmentMapRotation[2], -environmentMapRotation[1], environmentMapRotation[3])))
        .transpose();
    const euler = new THREE.Euler().setFromRotationMatrix(rotationMatrix);
    // set the currently used environment map
    data.obj.traverseVisible((child) => {
        if (child instanceof THREE.Mesh &&
            child.material instanceof THREE.Material) {
            const material = child.material;
            // for all materials that support env maps, set the env map
            if ("envMap" in material && "envMapIntensity" in material) {
                material.envMap = environmentMap;
                material.envMapIntensity = environmentMapIntensity;
                material.needsUpdate = true;
                for (const d in material.defines) {
                    if (d.startsWith("ENVMAP_TYPE_"))
                        delete material.defines[d];
                }
                if (material.defines)
                    material.defines["ENVMAP_TYPE_" + environmentMapType.toUpperCase()] = "";
            }
            if ("envMapRotation" in material) {
                material.envMapRotation = euler;
                material.needsUpdate = true;
            }
        }
    });
};
exports.assignEnvironmentMapForThreeJsDataObject = assignEnvironmentMapForThreeJsDataObject;
const assignEnvironmentMapForThreeJsData = (environmentMap, environmentMapType, environmentMapIntensity, environmentMapRotation) => {
    viewer_shared_node_tree_1.Tree.instance.root.traverse((node) => {
        node.data.forEach((data) => {
            if (data instanceof ThreejsData_1.ThreejsData) {
                (0, exports.assignEnvironmentMapForThreeJsDataObject)(data, environmentMap, environmentMapType, environmentMapIntensity, environmentMapRotation);
            }
        });
    });
};
exports.assignEnvironmentMapForThreeJsData = assignEnvironmentMapForThreeJsData;
//# sourceMappingURL=ThreeJsDataUtils.js.map